import React, { ReactNode } from 'react';

import { CardActions } from 'common/components/Card/card.styled';
import { Header, Title } from 'common/components/Card/InfoCard/InfoCard.styled';

interface IProps {
  title: string;
  actions?: ReactNode;
}

export const InfoCardTitle = ({ title, actions }: IProps) => {
  return (
    <Header>
      <Title>{title}</Title>
      {actions && <CardActions>{actions}</CardActions>}
    </Header>
  );
};
